import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ptg-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent implements OnInit {
  @Input() isLoading: boolean = false;
  @Input() textLoading: string = 'Loading...';
  @Input() classInput: string = '';

  constructor() {}

  ngOnInit(): void {}
}
